"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealVkusvillOrmlFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealVkusvillOrmlFilled = function MealVkusvillOrmlFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24.319 15.352c-3.905-2.456-9.917-4.505-9.332 2.065a34.398 34.398 0 00-6.874 4.143 48.205 48.205 0 01-3.76-3.45.581.581 0 00-.58-.165.583.583 0 00-.268.166.609.609 0 00-.146.285 19.934 19.934 0 000 7.534.608.608 0 00.146.284.582.582 0 00.58.167.582.582 0 00.269-.165c1.272-1.25 2.515-2.396 3.759-3.42C24.728 35.452 37 25.342 37 22.178c0-1.99-4.885-6.765-12.681-6.826zm6.333 6.69a1.43 1.43 0 01-.813-.254c-.24-.165-.427-.4-.538-.676a1.549 1.549 0 01-.083-.87 1.52 1.52 0 01.4-.772 1.45 1.45 0 01.749-.412c.284-.058.578-.029.845.085s.495.308.656.555a1.54 1.54 0 01-.182 1.903 1.441 1.441 0 01-1.034.441z",
    fill: "#97BA1E"
  }));
};

exports.MealVkusvillOrmlFilled = MealVkusvillOrmlFilled;
var _default = MealVkusvillOrmlFilled;
exports.default = _default;